import React from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";

function RetroPartyMay2023({ show, onClose, onOpen }) {
  // const [chatroomShow, setChatroomShow] = useState(false);
  // const handleChatroom = () => setChatroomShow(false);
  return (
    <div>
      <Modal
        size="xl"
        show={show}
        onHide={onClose}
        //  // backdrop="static"
        aria-labelledby="example-modal-sizes-title-lg"
        keyboard={false}
        animation={true}
        centered
      >
        <Modal.Body>
          <div className="Solera__Cont">
            <FiX className="Solera__Close" onClick={onClose} />
          </div>

          <div className="Exoc-Name">Retro Party May 2023</div>
          {/* <div className="Exco-Tittle">President</div> */}
          <br />

          {/* <div className="NO-Events">BBQ PARTY 2022</div> */}
          <br />
          <div>
            <div className="container-fluid p-0">
              <div className="row g-4">
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Rotary/1.jpg"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Rotary/2.jpg"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Rotary/3.jpg"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="container-fluid p-0">
              <div className="row g-4">
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Rotary/4.jpg"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Rotary/5.jpg"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Rotary/6.jpg"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="container-fluid p-0">
              <div className="row g-4">
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Rotary/7.jpg"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Rotary/8.jpg"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div>
                    <img
                      src="/assets/Rotary/9.jpg"
                      alt=""
                      className="Photogallary2 "
                    />
                  </div>
                </div>
              </div>
              <br />
              <div className="container-fluid p-0">
                <div className="row g-4">
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Rotary/10.jpg"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Rotary/11.jpg"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Rotary/12.jpg"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                </div>
                <br />
                <div className="container-fluid p-0">
                  <div className="row g-4">
                    <div className="col-lg-4">
                      <div>
                        <img
                          src="/assets/Rotary/13.jpg"
                          alt=""
                          className="Photogallary2 "
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div>
                        <img
                          src="/assets/Rotary/14.jpg"
                          alt=""
                          className="Photogallary2 "
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div>
                        <img
                          src="/assets/Rotary/15.jpg"
                          alt=""
                          className="Photogallary2 "
                        />
                      </div>
                    </div>
                  </div>
                  <br />
                  <div className="container-fluid p-0">
                    <div className="row g-4">
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/Rotary/16.jpg"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/Rotary/17.jpg"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/Rotary/18.jpg"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div className="container-fluid p-0">
                    <div className="row g-4">
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/Rotary/19.jpg"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/Rotary/20.jpg"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div>
                          <img
                            src="/assets/Rotary/21.jpg"
                            alt=""
                            className="Photogallary2 "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default RetroPartyMay2023;
